import React from 'react';
import '../portfolioProjectMovz/portfolioProjectMovz.css';

import OrangeStroke from '../../assets/portfolio/orange-stroke.svg';
import MovzHero2 from '../../assets/portfolio/movz-hero2.png';
import MovzDesign from '../../assets/portfolio/movz-design.png';
import MovzStart from '../../assets/portfolio/movz-start.png';
import MovzEnviro from '../../assets/portfolio/movz-enviro.png';
import MovzApps from '../../assets/portfolio/movz-apps.png';
import MovzStartLandscape from '../../assets/portfolio/movz-start-landscape.png';
import MovzHowItWorks from '../../assets/portfolio/movz-howitworks-landscape.png';
import MovzAppsLandscape from '../../assets/portfolio/movz-apps-landscape.png';
import MovzGetStarted from '../../assets/portfolio/movz-getstarted-landscape.png';

function PortfolioProjectMovz() {
    return (
        <div className="project-container">
            <img
                className="stroke-upper"
                src={OrangeStroke}
                alt="orange brush stroke"
            />

            <section className='hero-title'>
                <img
                    className='project-hero'
                    src={MovzHero2}
                    alt="movz hero"
                />

                <aside className="hero-textMovz">
                    <h2>Movz</h2>
                    <h3>
                        <a href="https://movz.se/" target="_blank" rel="noopener noreferrer">
                            movz.se
                        </a>
                    </h3>
                </aside>
            </section>

            <section className='project-section-width project-background-movzblue'>
                <article className='project-article-maxwidth'>
                    <aside>
                        <h2 className='project-h2'>The Job</h2>
                        <h3 className='project-h3'>UX | FRONTEND</h3>
                        <ul className='list-maxwidth job-list'>
                            <li>Create a new landing page.</li>
                            <li>Identify Movz needs and goals for the landing page.</li>
                            <li>Create design ideas in Figma.</li>
                            <li>Together with the product owner, decide on which design to go forward with.</li>
                            <li>Code up the website.</li>
                            <li>Redo UX design for the page.</li>
                            <li>Time scale: ten weeks.</li>
                        </ul>
                    </aside>
                    <aside className='margin-bottom extra-padding-bottom'>
                        <h2 className='project-h2'>Role</h2>
                        <p className='project-p'>
                            Entered into an up and running project for a start-up business in Karlstad where they needed help with a new landing page. As part of a team of four developers I worked with both frontend, UX design and planning.
                        </p>
                    </aside>
                </article>
            </section>

            <section className='project-section-width project-background-movzwhite extra-margin-bottom'>
                <article className='project-article-maxwidth extra-padding-top extra-padding-bottom'>
                    <h2 className='project-h2 dark-text'>Design Development</h2>
                    <p className='project-p dark-text'>
                        On entering into the project which had serveral focus areas, both frontend and backend that needed extensive work done on them to improve the product, I became part of a team of four given the task of creating a new landing page for the business. Seen through the whole project work was plit evently with 50% UX-design and 50% frontend development. The whole project was run remotely with developers working in various places in Sweden together with our CTO in Bangladesh. Our main contacts were with the company CEO (the product owner), and its CTO in Dhaka. Before starting the design process it was important to get to know the business and get a feel of where they wanted to go and what goals they had, so a lot of time was placed on design and development before actual programming began. Reasearch and meetings with the CEO and CTO gave an excellent base to start with and initial designs were produced on Figma and refined through a series of sprints.
                    </p>
                    <img className='designDev-img' src={MovzDesign} alt="design ideas" />
                    <p className='project-p dark-text'>
                        From these initial design prototypes a single design was chosen to work forward with and the next stage was to produce more refined prototypes for this design and a final design concept. This was done using Figma and FigJam in order to produce clear design ideas and workflows.
                    </p>
                    <div className='prototype-img-container'>
                        <img src={MovzStart} alt="design concept" />
                        <img src={MovzEnviro} alt="design concept" />
                        <img src={MovzApps} alt="design concept" />
                    </div>
                </article>
            </section>

            <section className='project-section-width project-background-movzblue'>
                <article className='project-article-maxwidth'>
                    <h2 className='project-h2'>Final Design</h2>
                    <p className='project-p'>
                        The finished landing page was then developed in collaboration with the CEO and CTO in accordance to the businesses profile. In close cooperation with the project owner and other designers and developers in a series of sprints, the final design was produced and refined.
                    </p>
                    <div className='final-design-imageContainer'>
                        <img className='img-size-final-design' src={MovzStartLandscape} alt="final design concept" />
                        <img className='img-size-final-design' src={MovzHowItWorks} alt="final design concept" />
                        <img className='img-size-final-design' src={MovzAppsLandscape} alt="final design concept" />
                        <img className='img-size-final-design' src={MovzGetStarted} alt="final design concept" />
                    </div>
                    <h2 className='project-h2'>Conclusion</h2>
                    <p className='project-p'>
                        This was an excellent opportunity to work with a real world project that ended up with our completed work being published. To be able to develop the landing page together with the CEO and CTO was an invaluable experience which through constructive feedback and excellent communication lead to the creating of a landing page which more than met the product owners expectations. <br /><br />Our group of four developers worked well together and our skills and interest areas complemeted each other very well. Id happily work with this group again.
                    </p>
                </article>
            </section>

            <img
                className="stroke-lower"
                src={OrangeStroke}
                alt="orange brush stroke"
            />
        </div>
    );
}

export default PortfolioProjectMovz;


